export default __webpack_public_path__ + "static/media/after_login.6d76d940.mp3";